module.exports = __webpack_public_path__ + "static/media/logo.348dbe87.svg";